import { useState } from "react";
export default function District({ district, setDistrict,district1, setDistrict1,district2,setDistrict2 }) {
  const handleClick = (index) => {
    district.includes(index) ?
	setDistrict(district.filter((d) => d !== index))
      : setDistrict([...district, index]);
  };
  const handleClick1 = (index) => {
    district1.includes(index)
      ? setDistrict1(district1.filter((d) => d !== index))
      : setDistrict1([...district1, index]);
  };
	const handleClick2 = (index) => {
    district2.includes(index)
      ? setDistrict2(district2.filter((d) => d !== index))
      : setDistrict2([...district2, index]);
  };
  const options = [
    ["Center", "ԿԵՆՏՐՈՆ"],
    ["Arabkir", "ԱՐԱԲԿԻՐ"],
    ["Davtashen", "ԴԱՎԹԱՇԵՆ"],
    ["Ajapnyak", "ԱՋԱՓՆՅԱԿ"],
    ["Vahagni-district", "ՎԱՀԱԳՆԻ ԹԱՂԱՄԱՍ"],
    ["Kanaker-Zeytun", "ՔԱՆԱՔԵՌ-ԶԵՅԹՈՒՆ"],
    ["Avan", "ԱՎԱՆ"],
    ["Nor-Norq", "ՆՈՐ ՆՈՐՔ"],
    ["Nork-Marash", "ՆՈՐՔ-ՄԱՐԱՇ"],
    ["Shengavit", "ՇԵՆԳԱՎԻԹ"],
    ["Malatia-Sebastia", "ՄԱԼԱԹԻԱ-ՍԵԲԱՍՏԻԱ"],
    ["Erebuni", "ԷՐԵԲՈՒՆԻ"],
  ];
  const options1 = [
    ["Jrvej", "ՋՐՎԵԺ"],
    ["Zovuni", "ԶՈՎՈՒՆԻ"],
    ["Dzoraghpyur", "ՁՈՐԱՂԲՅՈՒՐ"],
    ["Ptghni", "ՊՏՂՆԻ"],
    ["Arzni", "ԱՐԶՆԻ"],	  
    ["Qasakh", "ՔԱՍԱԽ"],
    ["Nor-Geghi", "ՆՈՐ ԳԵՂԻ"],
    ["Nor-Hajn", "ՆՈՐ ՀԱՃՆ"],
    ["Tsakhkadzor", "ԾԱՂԿԱՁՈՐ"],
    ["Abovyan", "ԱԲՈՎՅԱՆ"],
    ["Proshyan", "ՊՌՈՇՅԱՆ"],
    ["Arinj", "ԱՌԻՆՋ"],
    ["Byureghavan", "Բյուրեղավան"],
    ["Yeghvard", "Եղվարդ"],
  ];
  const options2 = [["Dilijan", "Դիլիջան"]]	
  
  return (
    <div
      className="district"
      style={{
        borderRadius: "10px",
        padding: "5px",
      }}
    >
      <div>
        <h5>ՀԱՄԱՅՆՔ</h5>
        
          <div className="with">
            <p style={{ margin: 1, fontWeight: "bold" }}>ԵՐԵՎԱՆ</p>
            {options.map(([eng, arm], index) => (
              <div key={index}>
                <input
                  type="checkbox"
                  name="district"
                  id={eng} // id лучше английский
                  value={eng} // value английский
                  checked={district.includes(index)}
                  onChange={() => handleClick(index)}
                />
                <label htmlFor={eng}>{arm}</label> {/* отображаем армянский */}
              </div>
            ))}
            <p style={{ margin: 1, fontWeight: "bold" }}>ԿՈՏԱՅՔ</p>
            {options1.map(([eng, arm], index) => (
              <div key={index}>
             				   <input
                  type="checkbox"
                  name="district"
                  id={eng} // id лучше английский
                  value={eng} // value английский
                  checked={district1.includes(index)}
                  onChange={() => handleClick1(index)}
                />
                <label htmlFor={eng}>{arm}</label> {/* отображаем армянский */}
              </div>
            ))}
		<p style={{ margin: 1, fontWeight: "bold" }}>ՏԱՎՈՒՇ</p>
            {options2.map(([eng, arm], index) => (
              <div key={index}>
                <input
                  type="checkbox"
                  name="district"
                  id={eng} // id лучше английский
                  value={eng} // value английский
                  checked={district2.includes(index)}
                  onChange={() => handleClick2(index)}
                />
                <label htmlFor={eng}>{arm}</label> {/* отображаем армянский */}
              </div>
            ))}
          </div>
        
      </div>
    </div>
  );
}
